<template lang="pug">
  #changeSa
    .container-width
      .p-4
        .ac_title.text-center.mb-3
          h4.font-weight-bold 更換我的美容顧問
        .border-0.ac_advisor.ac_advisor-old
          .d-flex.align-items-center.justify-content-center.w-100
            ProfilePhotoSticker.mr-3.d-flex.align-items-center.border.border-disable-light(
              :profileUrl="changeSaInfo.origin_sa.picture_url",
              :style="{ 'width': '70px', 'height': '70px' }"
              style="margin-right: 1rem !important"
            )
            .ac_advisor_info
              small 原美容顧問
              p.mt-2.mb-1.font-weight-bold.word-break-all {{ changeSaInfo.origin_sa.chinese_last_name }}{{ changeSaInfo.origin_sa.chinese_first_name }}
        .mb-4.ac_advisor.a_advisor-new.border-black.custom-shadow
          .d-flex.align-items-center.justify-content-center.w-100
            ProfilePhotoSticker.d-flex.align-items-center.border.border-black(
              :profileUrl="changeSaInfo.after_sa.picture_url",
              :style="{ 'width': '70px', 'height': '70px' }"
              style="margin-right: 1rem !important"
            )
            .ac_advisor_info
              small.d-block.mb-3.w-100 新美容顧問
              p.mb-1.w-100.font-weight-bold.word-break-all {{ changeSaInfo.after_sa.chinese_last_name }}{{ changeSaInfo.after_sa.chinese_first_name }}
          .ac_advisor_icon
            i.icon-icon_newBA
        .ac_text.text-center.mb-3
          span 點選確定即完成與新的美容顧問綁定
        .btn_wrap
          button.btn-custom.btn-b.mr-3(
            type="button",
            @click="confirmHandler()"
          )
            span.btn_text 確定
          button.btn-custom.btn-b(
            type="button",
            @click="$router.push({ name: 'm-my-sa' })"
          )
            span.btn_text 取消
</template>

<script>
import { mapState } from 'vuex';
import { M_BIND_SA_SUCCESS } from '@/router/member/bind-sa';

import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import iconArrowDownUrl from '@/assets/images/icon/icon_arrow_down.png';

export default {
  name: 'ChangeSaIndex',
  components: {
    ProfilePhotoSticker
  },
  mounted() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
  },
  data() {
      return {
          iconArrowDown: iconArrowDownUrl
      };
  },
  methods: {
    cancelHandler() {
      // 返回官方帳號連結
      window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
    },
    confirmHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '換綁中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });

      if (!vm.changeSaInfo || !vm.changeSaInfo.after_sa || !vm.changeSaInfo.after_store) {
        vm.$swal.fire({
          icon: 'error',
          title: '綁定失敗，請重新再嘗試一次[Err1]',
          showConfirmButton: false,
          showCancelButton: false,
          allowOutsideClick: false
        });
        return;
      }

      vm.$store.dispatch('member_change_sa/memberChangeBindingSaHandler', {
        sa_id: vm.changeSaInfo.after_sa.id,
        store_id: vm.changeSaInfo.after_store.id
      })
        .then((res) => {
          if (res.message === 'success') {
            vm.$swal.close();
            vm.$store.commit('member_bind_sa/setSaInfo', {
              sa: res.after_sa,
              store: res.after_store
            });
            vm.$router.push({
              name: M_BIND_SA_SUCCESS
            });
          } else {
            vm.$swal.fire({
              icon: 'error',
              title: '綁定失敗，請重新再嘗試一次[Err2]',
              showConfirmButton: false,
              showCancelButton: false
            });
          }
        });
    }
  },
  computed: {
    ...mapState({
      changeSaInfo: (state) => state.member_change_sa.changeSaInfo
    })
  }
};
</script>

<style scoped>
  .container-width {
    padding-top: 80px;
  }
  .ac_advisor {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-radius: 0.8rem;
    padding: 1.2rem;
    position: relative;
  }

  .ac_advisor-old {
    margin-bottom: 3.2rem;
    position: relative;
    background-color: #ddd;
  }

  .ac_advisor-old::after {
    display: block;
    content: "";
    position: absolute;
    width: 3rem;
    height: 4.2rem;
    background-image: url(../../../assets/images/icon/advisor-change-arrow-1.png);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    left: 50%;
    bottom: 0;
    -webkit-transform: translate(-50%, 90%);
    transform: translate(-50%, 90%);
    z-index: 1;
  }

  .ac_advisor-new {
    background-color: #fff;
  }

  .border-black {
    border: 0.2rem solid #000;
  }

  .custom-shadow {
    box-shadow: 0.2rem 0.2rem 0 rgb(0 0 0 / 20%);
  }

  @font-face {
    font-family: "icon";
    src: url("../../../assets/fonts/icon.eot?hrpp7d");
    src: url("../../../assets/fonts/icon.eot?hrpp7d#iefix") format("embedded-opentype"), url("../../../assets/fonts/icon.ttf?hrpp7d") format("truetype"), url("../../../assets/fonts/icon.woff?hrpp7d") format("woff"), url("../../../assets/fonts/icon.svg?hrpp7d#icon") format("svg");
    font-weight: normal;
    font-style: normal;
    font-display: block;
  }

  i {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: "icon" !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .ac_advisor_icon {
    position: absolute;
    font-size: 3rem;
    color: #000;
    top: -1.5rem;
    right: -1.2rem;
  }

  .icon-icon_newBA:before {
    content: "\e90a";
  }

  .ac_advisor_info {
    font-size: 1.2rem;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
  }

  .btn_wrap {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .btn-custom {
    background-color: $remind !important;
    color: #000 !important;
    border-radius: 9487px;
    font-size: 1rem;
    font-weight: 600;
    display: inline-block;
    text-align: center;
    -webkit-box-shadow: 0.1rem 0.1rem 0 rgba(0, 0, 0, 0.2);
    box-shadow: 0.1rem 0.1rem 0 rgba(0, 0, 0, 0.2);
    border: 0.2rem solid #000;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .btn-b {
    width: 100%;
    padding: 0.3rem 0;
  }

  .ac_text {
    font-size: 0.9rem;
    font-weight: 400;
  }
</style>
